var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "member-break-config" }, [
    _c("div", { staticClass: "source-section" }, [
      _c("h5", { staticClass: "section-title" }, [_vm._v("Break Schedule")]),
      _c("p", { staticClass: "source-help" }, [
        _vm._v(
          "\n            Choose where this driver's breaks come from.\n        "
        ),
      ]),
      _c(
        "div",
        { staticClass: "source-options" },
        [
          _c(
            "md-radio",
            {
              attrs: { value: _vm.BREAK_SOURCES.None },
              model: {
                value: _vm.source,
                callback: function ($$v) {
                  _vm.source = $$v
                },
                expression: "source",
              },
            },
            [_vm._v("None")]
          ),
          _c(
            "md-radio",
            {
              attrs: { value: _vm.BREAK_SOURCES.Team },
              model: {
                value: _vm.source,
                callback: function ($$v) {
                  _vm.source = $$v
                },
                expression: "source",
              },
            },
            [_vm._v("Team")]
          ),
          _c(
            "md-radio",
            {
              attrs: { value: _vm.BREAK_SOURCES.Custom },
              model: {
                value: _vm.source,
                callback: function ($$v) {
                  _vm.source = $$v
                },
                expression: "source",
              },
            },
            [_vm._v("Custom")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "source-actions" },
        [
          _c(
            "md-button",
            {
              staticClass: "md-primary",
              attrs: { disabled: !_vm.hasChanges() },
              on: { click: _vm.saveSource },
            },
            [_vm._v("\n                Save\n            ")]
          ),
        ],
        1
      ),
    ]),
    _vm.savedSource === _vm.BREAK_SOURCES.None
      ? _c("div", { staticClass: "source-detail" }, [
          _c("p", { staticClass: "no-result-message" }, [
            _vm._v("Breaks are disabled for this driver."),
          ]),
        ])
      : _vm.savedSource === _vm.BREAK_SOURCES.Team
      ? _c("div", { staticClass: "source-detail" }, [
          _c("p", { staticClass: "inherit-message" }, [
            _vm._v(
              "\n            This driver inherits the team break schedule. Edit it under Team Settings › Break Management.\n        "
            ),
          ]),
        ])
      : _vm.savedSource === _vm.BREAK_SOURCES.Custom
      ? _c("div", { staticClass: "source-detail" }, [
          _c("div", { staticClass: "custom-toolbar" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "custom-toolbar-end" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-round md-just-icon md-primary",
                    attrs: { title: "Add Break Schedule" },
                    on: {
                      click: function ($event) {
                        return _vm.setAddBreakState(true)
                      },
                    },
                  },
                  [_c("md-icon", [_vm._v("add")])],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm.breaksList.length != 0 || _vm.addBreakState
            ? _c(
                "div",
                [
                  _c(
                    "md-table",
                    {
                      staticClass:
                        "context-menu-support custom-paginated-table",
                    },
                    [
                      _c(
                        "draggable",
                        {
                          staticClass: "custom-draggable",
                          attrs: { draggable: ".drag-item" },
                          on: { change: _vm.breakScheduleOrderChanged },
                          model: {
                            value: _vm.breaksList,
                            callback: function ($$v) {
                              _vm.breaksList = $$v
                            },
                            expression: "breaksList",
                          },
                        },
                        [
                          _c(
                            "md-table-row",
                            [
                              _c("md-table-head", {
                                staticClass: "order-column",
                              }),
                              _c("md-table-head", [_vm._v("Break Schedule")]),
                              _c("md-table-head", [_vm._v("Action")]),
                            ],
                            1
                          ),
                          _vm._l(_vm.breaksList, function (item) {
                            return _c("team-break-row-component", {
                              key: item.breakScheduleId,
                              attrs: {
                                "team-break-details": item,
                                "break-count": _vm.breaksList.length,
                              },
                              on: {
                                editBreakScheduleClick: _vm.editBreakSchedule,
                                deleteBreakScheduleClick:
                                  _vm.deleteBreakSchedule,
                              },
                            })
                          }),
                          _vm.addBreakState
                            ? _c(
                                "md-table-row",
                                [
                                  _c(
                                    "md-table-cell",
                                    { staticClass: "order-align" },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.breaksList.length + 1) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                  _c("md-table-cell", [
                                    _vm._v(
                                      "\n                            Before completing\n                            "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.newEntry.drivingTimeMinutes,
                                          expression:
                                            "newEntry.drivingTimeMinutes",
                                        },
                                      ],
                                      staticClass: "minutes-textbox",
                                      attrs: {
                                        type: "text",
                                        onkeypress:
                                          "return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))",
                                      },
                                      domProps: {
                                        value: _vm.newEntry.drivingTimeMinutes,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.newEntry,
                                            "drivingTimeMinutes",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(
                                      "\n                            minutes of work take a\n                            "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.newEntry.breakTimeMinutes,
                                          expression:
                                            "newEntry.breakTimeMinutes",
                                        },
                                      ],
                                      staticClass: "minutes-textbox",
                                      attrs: {
                                        type: "text",
                                        onkeypress:
                                          "return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))",
                                      },
                                      domProps: {
                                        value: _vm.newEntry.breakTimeMinutes,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.newEntry,
                                            "breakTimeMinutes",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(
                                      "\n                            minute break.\n                        "
                                    ),
                                  ]),
                                  _c(
                                    "md-table-cell",
                                    [
                                      _c(
                                        "md-button",
                                        {
                                          staticClass:
                                            "md-round md-just-icon md-primary break-btn-icon",
                                          attrs: {
                                            title: "Add Break Schedule",
                                          },
                                          on: {
                                            click: _vm.createBreakSchedule,
                                          },
                                        },
                                        [_c("md-icon", [_vm._v("check")])],
                                        1
                                      ),
                                      _c(
                                        "md-button",
                                        {
                                          staticClass:
                                            "md-round md-just-icon md-danger break-btn-icon",
                                          attrs: { title: "Cancel" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.setAddBreakState(false)
                                            },
                                          },
                                        },
                                        [_c("md-icon", [_vm._v("cancel")])],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.breaksList.length == 0 && !_vm.addBreakState
            ? _c("div", { staticClass: "empty-custom" }, [_vm._m(1)])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "custom-toolbar-start" }, [
      _c("h6", { staticClass: "title" }, [_vm._v("Custom Break Schedule")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "no-result-message" }, [
      _vm._v(
        "\n                This driver takes no breaks (custom schedule with no rows). This is different from inheriting the\n                team schedule — add a row above, or switch to "
      ),
      _c("strong", [_vm._v("Team")]),
      _vm._v(" to inherit the team's breaks.\n            "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }